import axios from "axios";

import constants from "../../constants";

/**
 * Mensagens (/contacts): what arrived through a Keepo's form, newest first (contract: api-keepo-v2's ContactController and
 * FormSubmitted::editorView()).
 */

export type ContactField = {
  /** Old contacts (before the custom fields): which of the 4 fixed fields it is, for the editor to name it. */
  key?: "name" | "email" | "phone" | "message";
  /** As the form had it when the contact was sent ("" when it had none: the type names it). */
  label: string;
  type: string;
  /** As the person typed it (dates and yes/no already written out). */
  value: string;
};

export type Contact = {
  id: string;
  /** ISO 8601. */
  createdAt: string | null;
  /** Who sent it: the name, the e-mail, the phone or the first field. */
  title: string | null;
  /** What they wrote (cut in the list). */
  preview: string | null;
  fields: ContactField[];
};

export type ContactList = { items: Contact[]; total: number; page: number; perPage: number };

export const listContacts = async (siteId: string, page = 1): Promise<ContactList> => {
  const response = await axios.get(`${constants.api}/sites/${encodeURIComponent(siteId)}/contacts`, {
    params: page > 1 ? { page } : undefined,
  });
  return response.data;
};

export const getContact = async (siteId: string, contactId: string): Promise<Contact> => {
  const response = await axios.get(
    `${constants.api}/sites/${encodeURIComponent(siteId)}/contacts/${encodeURIComponent(contactId)}`
  );
  return response.data;
};
